"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPending = exports.getPendingIDs = void 0;
const getPendingIDs = (state) => state.pendingIDs || [];
exports.getPendingIDs = getPendingIDs;
const isPending = (state, id) => (0, exports.getPendingIDs)(state).includes(id);
exports.isPending = isPending;
//# sourceMappingURL=pendingIDsSelectors.js.map